<template>
    <td
        :class="[
            `column-${itemKey}`,
            !$slots[`item-${itemKey}`]
                ? 'whitespace-nowrap px-6 py-4'
                : 'w-auto',
        ]"
    >
        <p
            v-if="!$slots[`item-${itemKey}`]"
            class="truncate text-gray-500 lg:max-w-[270px]"
        >
            {{ item[itemKey] }}
        </p>
        <template v-else>
            <slot :name="`item-${itemKey}`" :row="item" :data="item[itemKey]" />
        </template>
    </td>
</template>

<script lang="ts" setup>
import type { IDataTableItem } from "../types/IDataTableItem";

defineProps<{
    itemKey: string;
    item: IDataTableItem;
}>();
</script>
